import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.small";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.find";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { fetchContent, fetchArticlesByTag } from '~/services/editorial';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import TcVars from '~/components/functional/TcVars/EditorialTcVars.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import GlobalNavigationBar from '~/components/molecules/Editorial/Global/GlobalNavigationBar.vue';
import GlobalListArticleCard from '~/components/organisms/Editorial/Global/GlobalListArticleCard.vue';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'Magazine',
  httpHeaders: function httpHeaders() {
    return {
      'Cache-Control': 'max-age=0, s-maxage=3600, public'
    };
  },
  components: {
    Seo: Seo,
    GlobalRichText: GlobalRichText,
    GlobalNavigationBar: GlobalNavigationBar,
    GlobalListArticleCard: GlobalListArticleCard,
    RatingJsonLd: RatingJsonLd,
    TcVars: TcVars
  },
  asyncData: function () {
    var _asyncData = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref14) {
      var params, error, store, _ref15, blogs, _blogs, blog, predicate, _blog$filters$find, label, _ref16, articles;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = _ref14.params, error = _ref14.error, store = _ref14.store;
              _context.prev = 1;
              _context.next = 4;
              return fetchContent(store, {
                type: 'blog'
              });

            case 4:
              _ref15 = _context.sent;
              blogs = _ref15.results;

              if (blogs.length) {
                _context.next = 8;
                break;
              }

              throw new Error({
                statusCode: 404,
                message: 'Not Found'
              });

            case 8:
              _blogs = _slicedToArray(blogs, 1), blog = _blogs[0].data;
              predicate = null;

              if (params.slug) {
                _blog$filters$find = blog.filters.find(function (filter) {
                  return filter.tag === params.slug;
                }), label = _blog$filters$find.label;
                predicate = {
                  tags: [label]
                };
              }

              _context.next = 13;
              return fetchArticlesByTag(store, predicate);

            case 13:
              _ref16 = _context.sent;
              articles = _ref16.results;
              return _context.abrupt("return", {
                blog: blog,
                articles: articles
              });

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](1);
              error({
                statusCode: 404,
                message: 'Not Found'
              });
              console.log(_context.t0);

            case 22:
              return _context.abrupt("return", false);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 18]]);
    }));

    function asyncData(_x) {
      return _asyncData.apply(this, arguments);
    }

    return asyncData;
  }(),
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  }), {
    selected: function selected() {
      return this.$route.params.slug || '';
    },
    currentBlog: function currentBlog() {
      var _this = this;

      var _ref8, _ref9, _ref10;

      if (this.$route.params.slug) {
        var _ref11, _ref12, _ref13;

        var selected = this.blog.filters.find(function (e) {
          return e.tag === _this.$route.params.slug;
        });
        return {
          title: (_ref13 = selected) != null ? _ref13.description : _ref13,
          image: {
            small: formatPrismicImage((_ref12 = selected) != null ? (_ref12 = _ref12.image) != null ? (_ref12 = _ref12.small) != null ? _ref12.url : _ref12 : _ref12 : _ref12) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref11 = selected) != null ? (_ref11 = _ref11.image) != null ? (_ref11 = _ref11.large) != null ? _ref11.url : _ref11 : _ref11 : _ref11) || EMPTY_PIXEL
          }
        };
      }

      return {
        title: ((_ref10 = this.blog) != null ? _ref10.title : _ref10) || [],
        image: {
          small: formatPrismicImage((_ref9 = this.blog) != null ? (_ref9 = _ref9.image) != null ? (_ref9 = _ref9.small) != null ? _ref9.url : _ref9 : _ref9 : _ref9) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref8 = this.blog) != null ? (_ref8 = _ref8.image) != null ? (_ref8 = _ref8.large) != null ? _ref8.url : _ref8 : _ref8 : _ref8) || EMPTY_PIXEL
        }
      };
    },
    currentSeo: function currentSeo() {
      var _this2 = this;

      var seo = this.blog;

      if (this.$route.params.slug) {
        var tag = seo.filters.find(function (e) {
          return e.tag === _this2.$route.params.slug;
        });
        seo.alternates = tag.alternates ? this.buildAlternates(tag.alternates) : [];

        if (tag.canonical) {
          seo.canonical = tag.canonical;
        }

        if (tag.meta_title) {
          seo.meta_title = tag.meta_title;
        }

        if (tag.meta_description) {
          seo.meta_description = tag.meta_description;
        }
      }

      return seo;
    },
    filters: function filters() {
      return this.blog.filters;
    },
    currentArticles: function currentArticles() {
      return this.articles.map(function (e) {
        var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;

        return {
          slug: e.slugs[0],
          tags: ((_ref7 = e) != null ? _ref7.tags : _ref7) || [],
          date: ((_ref6 = e) != null ? (_ref6 = _ref6.data) != null ? _ref6.date : _ref6 : _ref6) || '',
          title: ((_ref5 = e) != null ? (_ref5 = _ref5.data) != null ? (_ref5 = _ref5.main_title) != null ? (_ref5 = _ref5[0]) != null ? _ref5.text : _ref5 : _ref5 : _ref5 : _ref5) || '',
          difficulty: ((_ref4 = e) != null ? (_ref4 = _ref4.data) != null ? _ref4.difficulty : _ref4 : _ref4) || 0,
          readingTime: ((_ref3 = e) != null ? (_ref3 = _ref3.data) != null ? _ref3.reading_time : _ref3 : _ref3) || 0,
          image: {
            small: formatPrismicImage((_ref2 = e) != null ? (_ref2 = _ref2.data) != null ? (_ref2 = _ref2.image) != null ? (_ref2 = _ref2.small) != null ? _ref2.url : _ref2 : _ref2 : _ref2 : _ref2) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref = e) != null ? (_ref = _ref.data) != null ? (_ref = _ref.image) != null ? (_ref = _ref.large) != null ? _ref.url : _ref : _ref : _ref : _ref) || EMPTY_PIXEL
          }
        };
      });
    },
    tcVars: function tcVars() {
      return this.blog ? _objectSpread({}, this.blog, {
        env_template: 'Landing Page'
      }) : {};
    }
  }),
  methods: {
    buildAlternates: function buildAlternates(arg) {
      var _this3 = this;

      return arg.split(',').map(function (e) {
        var hreflang = e.split(':')[0];
        var market = hreflang.split('-')[1].toUpperCase();
        var language = hreflang.split('-')[0];
        var slug = e.split(':')[1];
        return {
          url: {
            url: "".concat(_this3.baseURL, "/").concat(market, "/").concat(language, "/e/magazine/").concat(slug)
          },
          hreflang: hreflang
        };
      });
    },
    navigateTo: function navigateTo(slug) {
      return {
        params: {
          slug: slug
        },
        hash: '#tabs'
      };
    },
    articlesList: function () {
      var _articlesList = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(slug) {
        var filter, _ref17, articles;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                filter = this.blog.filters.find(function (e) {
                  return e.tag === slug || '';
                });

                if (!filter) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return fetchArticlesByTag(this.$store, {
                  tags: [filter.label]
                });

              case 4:
                _ref17 = _context2.sent;
                articles = _ref17.results;
                this.articles = articles;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function articlesList(_x2) {
        return _articlesList.apply(this, arguments);
      }

      return articlesList;
    }()
  }
};